import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// SECURITY: auth lives in an httpOnly `session_token` cookie set by the
// backend. The frontend never reads or stores the token in JS, so XSS
// cannot exfiltrate it. `withCredentials:true` makes axios send the cookie
// on every cross-origin request.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Surface 401s globally so AuthContext can flip a logged-in user to the
// "session expired" state (toast + redirect) instead of silently failing.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && typeof window !== "undefined") {
      window.dispatchEvent(
        new CustomEvent("quill:unauthorized", { detail: { url: err.config?.url || "" } })
      );
    }
    return Promise.reject(err);
  }
);

export const fmtMoney = (n, ccy = "USD") => {
  const v = Number(n || 0);
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: ccy,
      maximumFractionDigits: 2,
    }).format(v);
  } catch {
    return `${v.toFixed(2)} ${ccy}`;
  }
};

export const fmtNum = (n) =>
  new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(Number(n || 0));

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  } catch {
    return iso;
  }
};
